const About = () => {
  const aboutList = [
    {
      img: "/images/about1.png",
      txt1: `365일&nbsp;<span class="text-point">무료상담</span>&nbsp;서비스`,
    },
    {
      img: "/images/about2.png",
      txt1: `<span class="text-point">출장비&nbsp;없는&nbsp;출장견적</span>`,
    },
    {
      img: "/images/about3.png",
      txt1: `소독&nbsp;및&nbsp;방역&nbsp;절차`,
    },
    {
      img: "/images/about4.png",
      txt1: `<span class="text-point">익명보장&nbsp;·&nbsp;비밀보장</span>`,
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="font-normal">
          청소의&nbsp;달인의{" "}
          <span className=" text-primary">약속&nbsp;4가지</span>
        </h2>
        <p className="text-lg mt-10">
          유품정리&nbsp;·&nbsp;특수청소만을&nbsp;전문으로&nbsp;하는
          정리&nbsp;및&nbsp;청소&nbsp;전문업체!
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-4 gap-5 lg:gap-6">
        {aboutList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full border btn6 inline-block"
          >
            <div className="relative w-full h-72 xl:h-96 overflow-hidden">
              <img
                className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                alt="img"
                src={v.img}
                width={414}
                height={506}
              />
            </div>
            <div className="absolute bottom-0 left-0 w-full h-fit py-2 bg-[rgba(4,96,255,0.8)] text-center text-white">
              <p
                className="gmedium text-2xl 2xl:text-2xl"
                dangerouslySetInnerHTML={{ __html: v.txt1 }}
              ></p>
            </div>
          </div>
        ))}
      </div>
      <div className=" relative w-full h-full text-center grid gap-5 lg:gap-10 mt-10 lg:mt-20">
        <div>
          <p className="text-lg lg:text-xl">
            유품정리&nbsp;·&nbsp;특수청소&nbsp;문의가
            처음인&nbsp;당신을&nbsp;위해!
          </p>
          <p className="text-lg lg:text-xl">
            <span className="text-primary">출장비&nbsp;없는&nbsp;출장견적</span>
            과{" "}
            <span className="text-primary">
              익명보장&nbsp;·&nbsp;비밀보장&nbsp;비대면&nbsp;견적
            </span>
            까지!
          </p>
        </div>
        <p className="text-lg lg:text-xl">
          고객님의&nbsp;입장에서&nbsp;생각하는
          고객감동&nbsp;실현&nbsp;해결&nbsp;전문업체
        </p>
      </div>
    </div>
  );
};

export default About;
